import React, { Component } from "react";

import {
  CModal,
  CModalHeader,
  CModalBody,
  CLabel,
  CInput,
  CModalFooter,
  CButton,
  CSpinner,
  CFormGroup,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CCardTitle
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { logout } from "../../actions/baseActions";
import URL from "../../config/api";
import axios from "../../config/axios";
import RichText from "../RichText/SlateEditor/Editor";
import "./css/content.css";

class TextCreator extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: "",
      ValorDescricao: "",
      descricao: "",
      loading: false,
      showOnly: false
    };
  }

  componentDidMount() {
    axios
      .get(`${URL.api}content/los/singleView/${this.props.currentLOLink}`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.setState({
          showOnly: this.props.showOnly,
          descricao: resp.data.data.slate_text,
          name: resp.data.data.name,
          ValorDescricao: JSON.parse(resp.data.data.slate_text)
        });
      });
  }

  setValorDescrição(val) {
    this.setState({
      // ValorDescrição: val
    });
  }

  insertLink() {
    if (this.state.ValorDescricao === "") {
      toastr.warning("Atenção", "Preencha o campo de descrição!");
      return;
    }

    if (this.state.name === "") {
      toastr.warning("Atenção", "Preencha o campo de nome!");
      return;
    }

    let obj = {
      name: this.state.name,
      type_id: 33,
      path: "",
      slate_text: JSON.stringify(this.state.ValorDescricao),
      ability_id: 1,
      released: true,
      private: true,
      flash: false,
      user_id: this.props.user.user.id,
      skin_id: 1,
      resume: "Text adicionado em uma atividade",
      objective: 1,
      image: "content/types/listaQuestoes.png",
      year: new Date().getFullYear(),
      author: this.props.user.user.name,
      source_id: 1,
      difficulty_level_id: 1,
      language_id: 1,
      status: "Liberado",
      printable: false
    };

    this.setState({ loading: true });

    axios
      .post(`${URL.api}content/los/insert`, obj, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.setState({ loading: false });
          this.props.getContent({
            type: 33,
            list: [{ id: resp.data.data, name: this.state.name }]
          });
          this.props.onClose();
        },
        error => {
          this.setState({ loading: false });
        }
      );
  }

  render() {
    return (
      <>
        {!this.state.showOnly ? (
          <CModal
            show={this.props.show}
            onClose={() => this.props.onClose()}
            centered
            closeOnBackdrop={false}
            size="lg w-100 h-100 m-0 p-0 mw-100 d-flex flex-column overflow-auto"
            style={{ width: "100%", height: "100%", borderRadius: "0" }}
          >
            <CModalHeader closeButton>Editor</CModalHeader>
            <CModalBody className="overflow-auto">
              <CFormGroup className="mt-3">
                <CLabel>Título</CLabel>
                <CInputGroup>
                  <CInputGroupPrepend>
                    <CInputGroupText>
                      <i className="fa fa-text-width" />
                    </CInputGroupText>
                  </CInputGroupPrepend>
                  <CInput
                    value={this.state.name}
                    onChange={e => this.setState({ name: e.target.value })}
                    placeholder="Nome do título"
                  />
                </CInputGroup>
              </CFormGroup>
              <CFormGroup className="mt-3 d-flex flex-column flex-1">
                <CLabel>Conteúdo</CLabel>
                <CInputGroup className="d-flex flex-column flex-1">
                  <RichText
                    setValorDescricao={val =>
                      this.setState({ ValorDescricao: val })
                    }
                    toolbar
                    description={this.state.descricao}
                    editavel
                  />
                </CInputGroup>
              </CFormGroup>
            </CModalBody>
            <CModalFooter>
              <CButton
                color="primary"
                className="d-flex justify-content-center align-items-center"
                disabled={this.state.loading}
                onClick={() => this.insertLink()}
              >
                <>
                  <span style={this.state.loading ? { opacity: 0 } : null}>
                    Inserir
                  </span>
                  {this.state.loading && (
                    <CSpinner
                      size="sm"
                      color="white"
                      style={{ position: "absolute" }}
                    />
                  )}
                </>
              </CButton>
            </CModalFooter>
          </CModal>
        ) : (
          <CModal
            show={this.props.show}
            onClose={() => this.props.onClose()}
            centered
            closeOnBackdrop={false}
            size="lg w-100 h-100 m-0 p-0 mw-100 d-flex flex-column"
            style={{ width: "100%", height: "100%", borderRadius: "0" }}
          >
            <CModalHeader closeButton>
              <CCardTitle>{this.state.name}</CCardTitle>
            </CModalHeader>
            <CModalBody className="overflow-auto">
              <CFormGroup className="d-flex flex-column flex-1">
                <CInputGroup className="d-flex flex-column flex-1">
                  <RichText
                    setValorDescricao={val =>
                      this.setState({ ValorDescricao: val })
                    }
                    toolbar
                    description={this.state.descricao}
                    editavel={false}
                  />
                </CInputGroup>
              </CFormGroup>
            </CModalBody>
            <CModalFooter>
              <CButton
                color="primary"
                className="d-flex justify-content-center align-items-center"
                onClick={() => this.props.onClose()}
              >
                Fechar
              </CButton>
            </CModalFooter>
          </CModal>
        )}
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(TextCreator);
